import { clearServerAnalyticsEvents } from './api';
import { swallowAndLogException } from './utils/swallowAndLog';
import { $devLog } from './utils/devLog';
import * as importedPlugins from './plugins';

const plugins = Object.values(importedPlugins);

export function init() {
  $devLog('analytics hub is initializing');

  plugins.forEach(plugin => {
    swallowAndLogException(() => {
      plugin.init?.();
    });
  });

  fireEventsFromServer();
}

async function fireEventsFromServer() {
  if (!drupalSettings?.serverAnalyticsEvents) {
    return;
  }
  
  drupalSettings.serverAnalyticsEvents.forEach(event => {
    fireAnalyticsEvent(event.id, event.data);
  });
  
  await clearServerAnalyticsEvents();
}

// Event considered "whitelisted" if there is no whitelist for the plugin,
// or if there is and the event is in it
function eventWhitelistedForPlugin(plugin, eventId) {
  return plugin.whitelist == null || 
    plugin.whitelist.length == 0 || 
    plugin.whitelist.has(eventId);
}

export function fireAnalyticsEvent(id, data) {
  plugins.forEach(plugin => {
    swallowAndLogException(() => {
      if (plugin.blacklist?.has(id) || plugin.manuallyFiredEvents?.has(id)) {
        return;
      }
  
      if (typeof plugin[id] === 'function') {
        plugin[id](id, data);
      }
      else if (typeof plugin.fireEvent === 'function' && eventWhitelistedForPlugin(plugin, id)) {
        plugin.fireEvent(id, data);
      }
    });
  });
}
